import { Routes } from '@angular/router';
import { RoutesConstants } from 'src/app/shared/common';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { AuthPagesGuard } from 'src/app/shared/guard';

export const AUTHENTICATION_ROUTES: Routes = [
  {
    path: '',
    component: RouterComponent,
    canActivate : [AuthPagesGuard],
    children: [
      {
        path: RoutesConstants.LOGIN_PAGE_URL,
        loadComponent: () =>
          import('./pages/login-page/login-page.component').then(
            (x) => x.LoginPageComponent
          ),
      },
      {
        path: RoutesConstants.FORGET_PASSWORD_PAGE_URL,
        loadComponent: () =>
          import(
            './pages/forget-password-page/forget-password-page.component'
          ).then((x) => x.ForgetPasswordPageComponent),
      },
    ],
  },
];
